import { SiteDesignGetPayload } from '../../../lib/types';
import { useServerSettingsPdfData } from './ServerSettingsPdfInitialization';

const ServerSettingsPdf = ({ siteDesignPayload }: ServerSettingsProps) => {

    const {
        genericSystemOverhead,
        genericMaxCamerasPerServer,
        genericConcurrentSmartClientStreams,
        genericMachineType,
        genericServerDiskQuantity,
        genericRaidOS,
        hasGenericArchiving,
        genericAddManagementServer,
        genericSupportedCameras,
        genericLiveDatabaseStorageConnectivity,
        genericLiveDatabaseRaidType,
        genericLiveDatabaseDiskType,
        genericLiveDatabaseDiskSizeMin,
        genericLiveDatabaseDiskSizeMax,
        genericArchiving,
        genericArchivingDatabaseArchivesPerDay,
        genericArchivingDatabaseStorageConnectivity,
        genericArchivingDatabaseRaidType,
        genericArchivingDatabaseDiskType,
        genericArchivingDatabaseDiskSizeMin,
        genericArchivingDatabaseDiskSizeMax
    } = useServerSettingsPdfData(siteDesignPayload)

    const isOptionsSetupLoaded = true; //maybe in the future we could remove this one if we are not using it.

    return (
        <div className="px-10 print-page-break">
            <div className="msds-text-header-5 msds-text-clear-blue py-1 mt-5">User Specified Request</div>
            <div className="msds-text-header-6 py-1 mt-1">Recording Server Settings</div>
            {
                isOptionsSetupLoaded && (
                    <div className='row xsd-proposals-pdf'>
                        <div className="col-4 xsd-proposals-pdf__server-setting-col-wrapper">
                            <div className="xsd-proposals-pdf__server-setting-col">
                                <div className="server-settings__header msds-text-header-3-bold mt-2">Main Settings</div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-2">
                                    <div>System overhead (%):</div>
                                    <div>{genericSystemOverhead}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Max cameras per server*:</div>
                                    <div>{genericMaxCamerasPerServer}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Concurrent Smart Client Streams:</div>
                                    <div>{genericConcurrentSmartClientStreams}</div>
                                </div>

                                <div className="server-settings__header msds-text-header-3-bold mt-2">Advanced Settings</div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-2">
                                    <div>Machine Type:</div>
                                    <div>{genericMachineType}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Max Disks Per Server:</div>
                                    <div>{genericServerDiskQuantity}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Raid OS:</div>
                                    <div>{genericRaidOS}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Archiving:</div>
                                    <div>{hasGenericArchiving}</div>
                                </div>

                                {genericAddManagementServer &&
                                    <>
                                        <div className="server-settings__header msds-text-header-3-bold mt-1">Managment Server Settings</div>
                                        <div className="msds-text-body-3 xsd-proposals-pdf__card-info my-2">
                                            <div>Supported Cameras:</div>
                                            <div>{genericSupportedCameras}</div>
                                        </div>
                                    </>
                                }

                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info my-1">
                                    <div>*Additional servers might be required, due to maximum amount of cameras exceeded.</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-4 xsd-proposals-pdf__server-setting-col-wrapper">
                            <div className="xsd-proposals-pdf__server-setting-col">
                                <div className="server-settings__header msds-text-header-3-bold mt-2">Live Database</div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-2">
                                    <div>Storage Connectivity:</div>
                                    <div>{genericLiveDatabaseStorageConnectivity}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Raid Array:</div>
                                    <div>{genericLiveDatabaseRaidType}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Disk Type:</div>
                                    <div>{genericLiveDatabaseDiskType}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Disk Size Min (TB):</div>
                                    <div>{genericLiveDatabaseDiskSizeMin}</div>
                                </div>
                                <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                    <div>Disk Size Max (TB):</div>
                                    <div>{genericLiveDatabaseDiskSizeMax}</div>
                                </div>
                            </div>
                        </div>

                        {genericArchiving && (
                            <div className="col-4 xsd-proposals-pdf__server-setting-col-wrapper">
                                <div className="xsd-proposals-pdf__server-setting-col">
                                    <div className="server-settings__header msds-text-header-3-bold">Archiving</div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info mt-1">
                                        <div>Archive Frequency (times per day):</div>
                                        <div>{genericArchivingDatabaseArchivesPerDay}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Storage Connectivity:</div>
                                        <div>{genericArchivingDatabaseStorageConnectivity}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Raid Array:</div>
                                        <div>{genericArchivingDatabaseRaidType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Type:</div>
                                        <div>{genericArchivingDatabaseDiskType}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Size Min (TB):</div>
                                        <div>{genericArchivingDatabaseDiskSizeMin}</div>
                                    </div>
                                    <div className="msds-text-body-3 xsd-proposals-pdf__card-info">
                                        <div>Disk Size Max (TB):</div>
                                        <div>{genericArchivingDatabaseDiskSizeMax}</div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        </div >
    )
}

export default ServerSettingsPdf

type ServerSettingsProps = {
    siteDesignPayload: SiteDesignGetPayload
}
